import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Salad, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

const DietaryAccommodations = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/dietary-accommodations`)
      .then((r) => setRows(r.data))
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="dietary-page">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2"><Salad className="h-6 w-6 text-green-600" /> Dietary Accommodations</h1>
        <p className="text-sm text-gray-600 mt-1">Current residents with dietary restrictions, food allergies, or other allergies — synced live from intake. Review before meal service.</p>
      </div>

      {loading ? <p className="text-gray-500">Loading...</p> : rows.length === 0 ? (
        <Card className="border-0 card-shadow"><CardContent className="py-10 text-center text-gray-500" data-testid="no-dietary">No dietary restrictions or allergies recorded for current residents. Add them on a resident's profile.</CardContent></Card>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {rows.map((r) => (
            <Card key={r.id} className="border-0 card-shadow" data-testid={`dietary-${r.id}`}>
              <CardHeader className="pb-2"><CardTitle className="text-lg">{r.first_name} {r.last_name}</CardTitle></CardHeader>
              <CardContent className="space-y-2">
                {r.dietary_restrictions && (
                  <div className="flex items-start gap-2 text-sm bg-red-50 border border-red-200 rounded-md p-2" data-testid={`dietary-restrictions-${r.id}`}>
                    <AlertCircle className="h-4 w-4 text-red-500 mt-0.5 shrink-0" />
                    <div><span className="font-semibold text-red-700">Dietary / Food Allergies:</span> <span className="text-gray-800">{r.dietary_restrictions}</span></div>
                  </div>
                )}
                {r.other_allergies && (
                  <div className="text-sm flex items-center gap-2" data-testid={`other-allergies-${r.id}`}><Badge className="bg-amber-100 text-amber-800">Other Allergies</Badge><span className="text-gray-800">{r.other_allergies}</span></div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default DietaryAccommodations;
